<div class="card">
    <p-message style="display: block; height: 3em" severity="info"
        text='The purpose of Vendor setup is (1) Match an "employee" vendor with an employee to allow sending expense reports to QuickBooks as a bill.
    (2) Grant a consultant access to timecard and/or expense reports. A consultant is a QuickBooks vendor that is assigned user credentials.'></p-message>
    <div class="table-container mt-3">
        <div class="flex items-center">
            <p-checkbox id="1099" binary="true" [(ngModel)]="only1099" (ngModelChange)="onOnly1099FilterChange($event)" #1099></p-checkbox>
            <label class="ml-2 font-bold">Only 1099</label>
        </div>
        <p-table stripedRows #dataTable dataKey="id" [scrollable]="true" scrollDirection="both" scrollHeight="70vh"
            [value]="vendors">
            <ng-template pTemplate="emptymessage">
                <tr class="empty-table">
                    <td [attr.colspan]="numCols" style="text-align: center">
                        <div class="tabulator-placeholder">
                            <span> No Data Available </span>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template #header let-item>
                <tr>
                    <!-- Status-->
                    <th class="status-cell">
                        <i class="pi pi-exclamation-circle" title="Status"></i>
                    </th>
                    <!-- Vendor-->
                    <th>
                        QuickBooks Vendor
                        <p-columnFilter field="VendorListID" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" class="ml-auto">
                            <ng-template #filter let-value let-filter="filterCallback">
                                <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                                    [options]="vendorFilterSelectItem" [filter]="true" styleClass="w-full"
                                [ngModel]="value"
                                (ngModelChange)="filter($event)">
                                </p-multiSelect>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <!-- Is Consultant-->
                    <th>Is Consultant</th>
                    <!-- Time as Con-->
                    <th>Consultant Time Entry</th>
                    <!-- Exp-->
                    <th>Expense Entry</th>
                    <!-- Linked Employee-->
                    <th>Expense User</th>
                </tr>
            </ng-template>
            <ng-template #body let-item let-edit="editing" let-ri="rowIndex" let-rowData>
                <tr data-id="row-{{ item.id }}">
                    <!-- Status-->
                    <td class="status-cell">
                        <div (click)="onStatusClick(item)" class="status-cell">
                            <ef-status-icon [status]="item?.Status?.StatusCode"
                                [message]="item?.Status?.Message"></ef-status-icon>
                        </div>
                    </td>
                    <!-- Vendor -->
                    <td>
                        {{ item?.VendorName }}
                    </td>
                    <td style="justify-content: center">
                        <i *ngIf="item.IsConsultant == true" style="justify-self: center" class="pi pi-check"></i>
                    </td>
                    <!-- Time as Con -->
                    <td>
                        <p-checkbox id="contime" [disabled]="item.IsConsultant == false" binary="true"
                            [(ngModel)]="item.ConTime" (ngModelChange)="onConTimeChange($event, item)"
                            #contime></p-checkbox>
                    </td>
                    <!-- Exp -->
                    <td>
                        <p-checkbox id="conexp" binary="true" [(ngModel)]="item.ConExp"
                            (ngModelChange)="onConExpChange($event, item)" #conexp></p-checkbox>
                    </td>
                    <!-- Linked Employee -->
                    <td>
                        <p-select [disabled]="item.ConExp == false" [style]="{ 'max-width': '100%', width: '100%' }"
                            [options]="employeesSelectItem" (onChange)="onEmployeeChange($event, item)"
                            [(ngModel)]="item.EmployeeListID" [filter]="true" appendTo="body" [autoDisplayFirst]="false"
                            placeholder="Link User">
                        </p-select>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
